import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://verabrief-api-production.up.railway.app';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('vb_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('vb_token');
      localStorage.removeItem('vb_user');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export const auth = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
};

export const sources = {
  list: () => api.get('/sources'),
  create: (data) => api.post('/sources', data),
  destroy: (id) => api.delete(`/sources/${id}`),
};

export const briefs = {
  today: () => api.get('/briefs/today'),
  history: () => api.get('/briefs/history'),
  generate: () => api.post('/briefs/generate'),
};

export default api;
